<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Select]
 * Select / обертка
 */

import { ref } from "vue";
import vSelect from "vue-select";

import useTranslate from "@/hooks/useTranslate/useTranslate";
import Chevron from "@/ui/icons/chevron.vue";

import Loader from "../icons/loader.vue";

const { isLoading } = defineProps<{ isLoading?: boolean }>();

const attributes = ref({
    ref: "openIndicator",
    role: "presentation",
    class: "vs__open-indicator",
});
</script>

<template>
    <vSelect>
        <template #open-indicator>
            <Loader v-if="isLoading" width="20px" height="20px" />
            <Chevron v-else v-bind="attributes" />
        </template>
        <template #option="option">
            <slot name="option" v-bind="option" />
        </template>
        <template #selected-option="option">
            <slot name="selected-option" v-bind="option" />
        </template>
        <template #no-options>
            <slot name="no-options">{{ useTranslate("tiw__vselect__notFound") }}</slot>
        </template>
    </vSelect>
</template>
